// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { EditablePropertyButton } from '@/components/editable-property-button';
import { Card, Stack, Typography } from '@mui/material';

interface Props {
  /**
   * The description text to display
   */
  description: string;
  /**
   * Called when the edit description button is clicked
   */
  onEditDescription: () => void;
}

/**
 * Displays the description section of a ticket in a card format.
 * Includes an editable button to modify the description inline.
 */
export function TicketDescription({ description, onEditDescription }: Props) {
  return (
    <Card variant="outlined">
      <Stack spacing={1} p={3}>
        <Typography variant="h6">Description</Typography>
        <EditablePropertyButton
          variant="body1"
          onClick={onEditDescription}
          sx={{
            whiteSpace: 'pre-wrap',
            textAlign: 'left',
            borderLeft: '2px solid',
            borderColor: 'primary.main',
            borderRadius: 0,
          }}
        >
          {description}
        </EditablePropertyButton>
      </Stack>
    </Card>
  );
}
